import { ReactNode } from "react";
import FeatureFlagContext from "../../tp-core-types/FeatureFlagsModel";

export function FeatureFlagContextProvider({ children }: { children: ReactNode }) {
    const defaultFeatureFlag = {
        featureFlag: {
            featureFlag_HcpApplication_SkillsChecklist_IsEnabled: process.env.REACT_APP_FEATUREFLAG_HCPAPPLICATION_SKILLSCHECKLIST_ISENABLED === "true",
            featureFlag_DashboardAssignments_IsEnabled: process.env.REACT_APP_FEATUREFLAG_DASHBOARDASSIGNMENTS_ISENABLED === "true",
            featureFlag_DocumentsAndSignatures_IsEnabled: process.env.REACT_APP_FEATUREFLAG_DOCUMENTSANDSIGNATURES_ISENABLED === "true",
            featureFlag_ReferAFriend_IsEnabled: process.env.REACT_APP_FEATUREFLAG_REFERAFRIEND_ISENABLED === "true",
            featureFlag_CredentialsDropbox_IsEnabled: process.env.REACT_APP_FEATUREFLAG_CREDENTIALSDROPBOX_ISENABLED === "true",
            featureFlag_UpdateBackgroundQuestions_IsEnabled: process.env.REACT_APP_FEATUREFLAG_UPDATEBACKGROUNQUESTIONS_ISENABLED === "true",
            featureFlag_Timesheets_IsEnabled: process.env.REACT_APP_FEATUREFLAG_TIMESHEETS_ISENABLED === "true",
            featureFlag_HubIsSunset: process.env.REACT_APP_FEATUREFLAG_HUBISSUNSET === "true",
            featureFlag_Rto_IsEnabled: process.env.REACT_APP_FEATUREFLAG_RTO_ISENABLED === "true",
            featureFlag_Terms_First: process.env.REACT_APP_FEATUREFLAG_TERMS_FIRST === "true"
        },
    };

    return <FeatureFlagContext.Provider value={defaultFeatureFlag}>{children}</FeatureFlagContext.Provider>;
}
